import {
  Form,
  Input,
  Checkbox,
  Link,
  Button,
  Space,
  Tabs, 
} from '@arco-design/web-react';
import { FormInstance } from '@arco-design/web-react/es/Form';
import { IconLock, IconUser } from '@arco-design/web-react/icon';
import React, { useEffect, useRef,Dispatch,SetStateAction, useState } from 'react';
// import axios from 'axios';
import axiosInstance from '@/utils/axiosInstance';
import userInfo from '@/utils/userInfo';
import useStorage from '@/utils/useStorage';
import useLocale from '@/utils/useLocale';
import locale from './locale';
import styles from './style/index.module.less';
const TabPane = Tabs.TabPane;

interface loginProp{
	setisShowLogin:Dispatch<SetStateAction<boolean>>;
	setisShowRegist:Dispatch<SetStateAction<boolean>>;
	setisShowrest:Dispatch<SetStateAction<boolean>>;
	termToken:string | null;
	termUsername: string | null;
	aliCaptchaPrefix: string;
	aliCaptchaSceneIdWeb: string;
}



export default function LoginForm(prop:loginProp) {
	const formRef = useRef<FormInstance>();
	const formSmsRef = useRef<FormInstance>();
	
	const [errorMessage, setErrorMessage] = useState('');
	const [loading, setLoading] = useState(false);
	const [loginParams, setLoginParams, removeLoginParams] =
    useStorage('loginParams');
	const t = useLocale(locale);
	const [rememberPassword, setRememberPassword] = useState(!!loginParams);


	const [form] = Form.useForm();
	const [qcodebtn,setqcodebtn] = useState(false);
	const rcodebtn = useRef(false);
	const [qphone,setqphone] =  useState('');
	const rphone = useRef('');
	const [imgCode,setimgCode] = useState('');
	const [timeText,settimeText] = useState('获取验证码');
	const [timeNum,settimeNum] = useState(0);
	const rtimeNume = useRef(0);
	const [isRunning,setisRunning] = useState(false);

	
	const [captchaImg,setcaptchaImg] = useState('');
	const [captchaUniqid,setcaptchaUniqid] = useState('');
	
	
	if(prop.termToken!=null&&prop.termUsername!=null){
		// 记录登录状态
		localStorage.setItem('userStatus', 'login');
		localStorage.setItem('username', prop.termUsername);
		localStorage.setItem('token', prop.termToken);
		// 跳转首页
		setTimeout(()=>{
			window.location.href = '/home';
		},1000)
	}

	function afterLoginSuccess(params,token,role) {
		// 记住密码
		if (rememberPassword) {
		  setLoginParams(JSON.stringify(params));
		} else {
		  removeLoginParams();
		}
		// 记录登录状态
		localStorage.setItem('userStatus', 'login');
		localStorage.setItem('username', params.username?params.username:params.phone);
		localStorage.setItem('token', token);
		localStorage.setItem('role', role);
		// 跳转首页
		
		userInfo.info();
		userInfo.config();
		

		setTimeout(()=>{
			window.location.href = '/home';
		},1000)
	}
	
  function login(params) {

    setErrorMessage('');
    setLoading(true);
    axiosInstance.post('/login/handler', params)
      .then((res) => {
        const { code, msg } = res.data;
        if (res.data.code === 0) {
          afterLoginSuccess(params,res.data.data.token,res.data.data.role);
        } else {
          setErrorMessage(msg || t['login.form.login.errMsg']);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function onSubmitClick() {
    formRef.current.validate().then((values) => {
      login(values);
    });
  }
  function smslogin(params) {
    setErrorMessage('');
    setLoading(true);
    axiosInstance.post('/login/sms', params)
      .then((res) => {
        const { code, msg } = res.data;
        if (res.data.code === 0) {
          afterLoginSuccess(params,res.data.data.token,res.data.data.role);
        } else {
          setErrorMessage(msg || t['login.form.login.errMsg']);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }
  function onSmsSubmitClick() {
    formSmsRef.current.validate().then((values) => {
      smslogin(values);
    });
  }

  // 读取 localStorage，设置初始值
	useEffect(() => {
		const rememberPassword = !!loginParams;
		setRememberPassword(rememberPassword);
		if (formRef.current && rememberPassword) {
		  const parseParams = JSON.parse(loginParams);
		  formRef.current.setFieldsValue(parseParams);
		}
	}, [loginParams]);
	const style = {
	  textAlign: 'center',
	  marginTop: 20,
	};
	const cphone = (e)=>{
			const phone = e.trim();
			if(phone.length==11){
				setqcodebtn(true);
				rcodebtn.current = true;
			}else{
				setqcodebtn(false);
				rcodebtn.current = false;
			}
			setqphone(phone)
			rphone.current = phone
	}
	const captchaVerifyCallback = async (captchaVerifyParam) => {
		if(!rcodebtn.current||rtimeNume.current>0){
			return {
			    captchaResult: true,
				bizResult: true
			}
		}
		const res = await axiosInstance.post('/sms/send_v2', {
			method:'login',
			captchaVerifyParam:JSON.parse(captchaVerifyParam),
			phone:rphone.current,
		})
	
		let captchaResult = false;
		let bizResult = false;
		    if (res.data.code === 0) {
				settimeNum(60);
				rtimeNume.current=60
				setisRunning(true)
				setErrorMessage('');
				captchaResult = true;
				bizResult = true;
			
		    } else {
				if (res.data.code === 90011) {
					captchaResult = false;
					bizResult = false;
					
				}else{
					setErrorMessage(res.data.msg);
					captchaResult = true;
					bizResult = true;
				}
			}
		return {
		    captchaResult: captchaResult,
		    bizResult: bizResult,
		}
		
	   
	}
	const onBizResultCallback = ()  => {
	    console.log('onBizResultCallback');
	}
	let captcha;
	const getInstance = (instance) => {
	    captcha = instance;
	};

	useEffect(() => {
	  let countdown;
	  if (isRunning && timeNum > 0) {
	    countdown = setTimeout(() => {
			  settimeNum(timeNum - 1)
			  rtimeNume.current = timeNum - 1
			  settimeText(String(timeNum)+'s后重发')
		  }, 1000);
	  } else if (timeNum === 0) {
	    setisRunning(false);
		  settimeText('获取验证码')
		  
	    // 在这里可以执行发送验证码的操作
	  }
	  return () => clearTimeout(countdown);
	}, [isRunning, timeNum]);
	

	function changeTab(e){
		if(e==2){
			// axiosInstance.get('/system/config')
			//   .then((res) => {
			//     if (res.data.code === 0) {
				
					(window as any).initAliyunCaptcha({
						SceneId: prop.aliCaptchaSceneIdWeb, // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
						prefix: prop.aliCaptchaPrefix, // 身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
						mode: 'popup', // 验证码模式。popup表示要集成的验证码模式为弹出式。无需修改
						element: '#captcha-element', // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
						button: '#captcha-button', // 触发验证码弹窗的元素。button表示单击登录按钮后，触发captchaVerifyCallback函数。您可以根据实际使用的元素修改element的值
						captchaVerifyCallback: captchaVerifyCallback, // 业务请求(带验证码校验)回调函数，无需修改
						onBizResultCallback: onBizResultCallback, // 业务请求结果回调函数，无需修改
						getInstance: getInstance, // 绑定验证码实例函数，无需修改
						slideStyle: {
							width: 360,
							height: 40,
						}, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
						language: 'cn', // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
					});
					 		
			//     }
			// })
				
			return () => {
				document.getElementById('aliyunCaptcha-mask')?.remove();
				document.getElementById('aliyunCaptcha-window-popup')?.remove();
			}
		}
	}
  return (
    <div className={styles['login-form-wrapper']}>
		<Tabs defaultActiveTab='1' size='large' onChange={(e)=>changeTab(e)}>
			<TabPane key='1' title='密码登录' >
				<>
					<div className={styles['login-form-error-msg']}>{errorMessage}</div>
					<Form
						className={styles['login-form']}
						layout="vertical"
						ref={formRef}
						initialValues={{ username: '', password: '' }}
					>
						<Form.Item
						  field="username"
						  rules={[{ required: true, message: '用户名不能为空' }]}
						>
							<Input
								prefix={<IconUser />}
								placeholder={t['login.form.username.placeholder']}
								onPressEnter={onSubmitClick}
								autoComplete="username"
							/>
						</Form.Item>
						<Form.Item
						  field="password"
						  rules={[{ required: true, message: t['login.form.password.errMsg'] }]}
						>
							<Input.Password
								prefix={<IconLock />}
								onPressEnter={onSubmitClick}
								autoComplete="current-password" 
							/>
						</Form.Item>
						<Space size={16} direction="vertical">
							<div className={styles['login-form-password-actions']}>
								<Checkbox checked={rememberPassword} onChange={setRememberPassword}>
									记住密码
								</Checkbox>
								<span  
								style={{color:'#165DFF',cursor:'pointer'}}
								onClick={()=>{
									prop.setisShowLogin(false);
									prop.setisShowrest(true);
								}} 
								>忘记密码</span>
							</div>
							<Button type="primary" long onClick={onSubmitClick} loading={loading}>
								{t['login.form.login']}
							</Button>
							<Button
								type="text"
								long
								className={styles['login-form-register-btn']}
								onClick={()=>{
									prop.setisShowLogin(false);
									prop.setisShowRegist(true);
								}} 
							>
								{t['login.form.register']}
							</Button>
						</Space>
					</Form>
				</>
			</TabPane>
			<TabPane key='2' title='验证码登录'>
				<>
				<div className={styles['login-form-error-msg']}>{errorMessage}</div>
				<Form
					form={form}
					className={styles['login-form']}
					layout="inline"
					ref={formSmsRef}
					initialValues={{ phone: '', sms_code:'' }}
				>
					<Form.Item
						field="phone"
						rules={[{ required: true, message:'登录手机号不能为空' }]}
						style={{marginBottom:20}}
					>
				    <Input
						prefix={<IconUser />}
						style={{width:320}}
						onChange={(e)=>cphone(e)}
						placeholder='登录手机号'
				    />
					</Form.Item>
					<Form.Item
					  field="sms_code"
					  rules={[{ required: true, message: '验证码不能为空'}]}
					>
					<Input
						style={{width:180}}
						placeholder='验证码'
					/>
					</Form.Item>
					<div id="captcha-button" style={{display:timeNum<=1?'block':'none'}}  className={!qcodebtn||timeNum>=1?styles['ewei-btn-dis']:styles['ewei-btn']} >{timeText}</div>
					<div id="captcha-element"></div>
					<div style={{display:timeNum>1?'block':'none'}}  className={!qcodebtn||timeNum>=1?styles['ewei-btn-dis']:styles['ewei-btn']} >{timeText} </div>
					
					<div style={{width:320,height:52}}>
						
					</div>
					
					<Space size={16} direction="vertical">
						<Button style={{width:320}} type="primary" long onClick={onSmsSubmitClick} loading={loading}>
							{t['login.form.login']}
						</Button>
						<Button
							style={{width:320}}
							type="text"
							long
							className={styles['login-form-register-btn']}
							onClick={()=>{
								prop.setisShowLogin(false);
								prop.setisShowRegist(true);
							}} 
						>
							{t['login.form.register']}
						</Button>
					</Space>
				</Form>
				</>
			</TabPane>
		</Tabs>
			
		{/*
		<div className={styles['login-form-title']}>登录</div>
		*/}
        
    </div>
  );
}
